import Script from 'next/script';

interface IImpactScriptProps {
  cspNonce: string;
  isOneTrustEnabled: boolean;
}

export const ImpactScript = ({ cspNonce, isOneTrustEnabled }: IImpactScriptProps) => {
  return (
    <Script
      id="impact-script-1"
      key="impact"
      nonce={cspNonce}
      async
      className="optanon-category-C0004"
      type={isOneTrustEnabled ? 'text/plain' : 'text/javascript'}
    >
      {`
        (function(a, b, c, d, e, f, g) {
          e['ire_o'] = c;
          e[c] = e[c] || function() {
            (e[c].a = e[c].a || []).push(arguments)
          };
          f = d.createElement(b);
          g = d.getElementsByTagName(b)[0];
          f.async = 1;
          f.src = a;
          g.parentNode.insertBefore(f, g);
        })('https://d.impactradius-event.com/A2531724-4768-4093-a3f8-41213520467b1.js', 'script', 'ire', document, window);
      `}
    </Script>
  );
};
